export default __webpack_public_path__ + "static/media/plus.fa5a7fb5.svg";